import React, { Component } from 'react';
import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';

import { PROCESS_ORDER_FORM_NAME } from 'Common/FormEnum';
import { ManageProcessOrderEnum } from 'Common/FieldEnum';
import { PreviewProcessOrderEnum } from 'Common/FieldEnum';
import { errorToast } from 'Common/ToastHelper';
import { ReportGeneration } from 'Common/ObjectHelper';

import ProcessOrder from '../../components/processOrder/ProcessOrder';
import {
  setProcessedOrderPreviewData,
  createPurchaseWarehouseBackOrders,
  getPreviewOrders,
  clearPreviewOrderError,
  getPrintPreviewData,
  getPrintVendorSummaryData,
  clearPrintVendorSummary,
  clearPrintPreviewData,
} from '../../state/processOrder/actions';
import 'Styles/pages/inventory/manageprocessorder/index.less';

class ProcessOrderContainer extends Component {
  static path = '/manageprocessorder/process';
  state = {
    showCancelDialog: false,
  };
  componentDidMount() {
    this.props.getPreviewOrders();
  }
  componentDidUpdate(prevProps) {
    const { printVendorData, printPreviewData } = this.props;
    if (
      errorToast(this.props, prevProps, 'submitError') ||
      errorToast(this.props, prevProps, 'previewOrderError') ||
      errorToast(this.props, prevProps, 'printError')
    ) {
      this.props.clearPreviewOrderError();
    }
    if (printVendorData && printVendorData !== prevProps.printVendorData) {
      ReportGeneration(
        this.props.printVendorData,
        'Distributor Summary Report'
      );
      this.props.clearPrintVendorSummary();
    }
    if (printPreviewData && printPreviewData !== prevProps.printPreviewData) {
      printPreviewData[ManageProcessOrderEnum.BOPrintResult] &&
        ReportGeneration(printPreviewData.BOPrintResult, 'BO Report');
      printPreviewData[ManageProcessOrderEnum.POPrintResult] &&
        ReportGeneration(printPreviewData.POPrintResult, 'PO Report');
      printPreviewData[ManageProcessOrderEnum.WOPrintResult] &&
        ReportGeneration(printPreviewData.WOPrintResult, 'WO Report');
      printPreviewData[ManageProcessOrderEnum.KOPrintResult] &&
        ReportGeneration(printPreviewData.KOPrintResult, 'KO Report');
      this.props.clearPrintPreviewData();
    }
  }
  getRootUrl = () => {
    const { url } = this.props.match;
    return url.substring(0, url.lastIndexOf('/'));
  };
  getMainProps = () => {
    return {
      toolbox: {
        rightButtons: [
          {
            content: 'Create',
            onClick: this.onSaveClick,
          },
          {
            content: 'Cancel',
            onClick: this.onCancelBtnClick,
          },
        ],
        shown: true,
      },
    };
  };

  onSaveClick = () => {
    const { processedOrderData } = this.props;
    processedOrderData &&
      processedOrderData.OrderSummary &&
      processedOrderData.OrderSummary.length &&
      this.props.createPurchaseWarehouseBackOrders(
        processedOrderData.OrderSummary,
        this.redirectToRootPage
      );
  };

  onCancelBtnClick = () => {
    this.setState({
      showCancelDialog: true,
    });
  };
  redirectToRootPage = () => {
    this.props.history.replace(this.getRootUrl());
  };
  onCancelClick = result => {
    if (result) {
      this.props.setProcessedOrderPreviewData([]);
      this.redirectToRootPage();
    }
    this.setState({ showCancelDialog: false });
  };

  onPrintPreviewClick = () => {
    const sortBy =
      this.props.printOptionsValue === PreviewProcessOrderEnum.ItemCode
        ? PreviewProcessOrderEnum.ItemCode
        : PreviewProcessOrderEnum.ItemDescription;
    this.props.getPrintPreviewData(sortBy);
  };

  onPrintVendorSummaryClick = () => {
    const sortBy =
      this.props.printOptionsValue === PreviewProcessOrderEnum.ItemCode
        ? PreviewProcessOrderEnum.ItemCode
        : PreviewProcessOrderEnum.ItemDescription;
    this.props.getPrintVendorSummaryData(sortBy);
  };
  onMessageClick = () => {
    const { processedOrderData } = this.props;
    processedOrderData &&
      processedOrderData[PreviewProcessOrderEnum.ExpiredBidsResult] &&
      processedOrderData[PreviewProcessOrderEnum.ExpiredBidsResult][
        PreviewProcessOrderEnum.ReportSteamResult
      ] &&
      ReportGeneration(
        processedOrderData[PreviewProcessOrderEnum.ExpiredBidsResult][
          PreviewProcessOrderEnum.ReportSteamResult
        ],
        'Expired Bid Price'
      );
  };
  render() {
    return (
      <ProcessOrder
        getMainProps={this.getMainProps}
        processedOrderData={this.props.processedOrderData}
        printOptionsValue={this.props.printOptionsValue}
        onCancelClick={this.onCancelClick}
        showCancelDialog={this.state.showCancelDialog}
        createLoading={this.props.createLoading}
        onPrintPreviewClick={this.onPrintPreviewClick}
        onPrintVendorSummaryClick={this.onPrintVendorSummaryClick}
        printLoading={this.props.printLoading}
        onMessageClick={this.onMessageClick}
      />
    );
  }
}

const mapStateToProps = state => {
  const { processOrder } = state.ManageOrderItemState;
  const {
    submitted,
    submitError,
    previewOrderError,
    createLoading,
    processedOrderData,
    printLoading,
    printError,
    printVendorData,
    printPreviewData,
  } = processOrder;
  const selector = formValueSelector(PROCESS_ORDER_FORM_NAME);
  return {
    submitted: submitted,
    submitError: submitError,
    initialValues: {
      PrintOptions: PreviewProcessOrderEnum.ItemCode,
    },
    printOptionsValue: selector(state, PreviewProcessOrderEnum.PrintOptions),
    previewOrderError: previewOrderError,
    createLoading: createLoading,
    processedOrderData: processedOrderData,
    printLoading: printLoading,
    printError: printError,
    printVendorData,
    printPreviewData,
  };
};
ProcessOrderContainer = reduxForm({
  enableReinitialize: true,
  destroyOnUnmount: false,
  form: PROCESS_ORDER_FORM_NAME,
})(ProcessOrderContainer);

export const ProcessOrderForm = connect(
  mapStateToProps,
  {
    setProcessedOrderPreviewData,
    createPurchaseWarehouseBackOrders,
    getPreviewOrders,
    clearPreviewOrderError,
    getPrintPreviewData,
    getPrintVendorSummaryData,
    clearPrintVendorSummary,
    clearPrintPreviewData,
  }
)(ProcessOrderContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/manageprocessorder/containers/processOrder/ProcessOrder.js